import { schoolMarkingAccess } from "../schoolMarkingAccess";

const getMaxScore = (itemId, mode, schoolCode) => {
  const hasSchoolMarkingAccess = schoolMarkingAccess.includes(schoolCode);

  if (mode === "Pre-S1") {
    switch (itemId) {
      case 0:
        return 35;
      case 1:
        return 15;
      case 2:
        return 7;
      case 3:
        return 10;
      case 4:
        return 3;
      case 5:
        return 0;
      default:
        return 0;
    }
  } else if (mode === "IGCSE") {
    switch (itemId) {
      case 0:
        return 28;
      case 1:
        return 10;
      case 2:
        return 10;
      case 3:
        return 8;
      case 11:
        return 5;
      case 12:
        return 5;
      case 13:
        return 5;
      case 21:
        return 5;
      case 22:
        return 5;
      case 23:
        return 5;
      case 31:
        return 4;
      case 32:
        return 4;
      default:
        return 0;
    }
  } else if (mode === "DSE") {
    switch (itemId) {
      case 11:
        return 6;
      case 12:
        return 5;
      case 13:
        return 5;
      case 14:
        return 5;
      case 21:
        return 5;
      case 22:
        return 5;
      case 23:
        return 5;
      case 3:
        return 5;
      default:
        return 0;
    }
  } else if (
    mode === "TSA-小六級" ||
    mode === "TSA-中三級" ||
    mode.includes("TSA")
  ) {
    switch (itemId) {
      case 1:
        return 5;
      case 2:
        return 5;
      case 3:
        return 4;
      case 4:
        return 4;
      case 5:
        return 3;
      case 6:
        return 3;
      default:
        return 0;
    }
  } else if (mode === "IB") {
    switch (itemId) {
      case 1:
        return 5;
      case 2:
        return 5;
      case 3:
        return 4;
      default:
        return 0;
    }
  } else if (mode === "中國語文第二語言學習架構") {
    switch (itemId) {
      case 1:
        return "NLW(8.1.3)";
      case 2:
        return "NLW(8.2.1)";
      case 3:
        return "NLW(8.3.2)";
      case 4:
        return "NLW(8.5.2)";
      default:
        return "／";
    }
  } else if (mode === "校本評核" && hasSchoolMarkingAccess) {
    // 聖三一堂小學
    switch (itemId) {
      case 1:
        return 30;
      case 2:
        return 30;
      case 3:
        return 20;
      case 4:
        return 10;
      case 5:
        return 5;
      case 6:
        return 5;
      default:
        return "／";
    }
  }
};

const getNLFAccessmentScoreList = (mode, itemId) => {
  if (mode === "中國語文第二語言學習架構") {
    switch (itemId) {
      case 1:
        return [
          "NLW(1.1.4)",
          "NLW(1.1.5)",
          "NLW(2.1.1)",
          "NLW(2.1.2)",
          "NLW(3.1.1)",
          "NLW(3.1.2)",
          "NLW(4.1.1)",
          "NLW(4.1.2)",
          "NLW(5.1.1)",
          "NLW(5.1.2)",
          "NLW(6.1.1)",
          "NLW(6.1.2)",
          "NLW(7.1.3)",
          "NLW(8.1.2)",
          "NLW(8.1.3)",
        ];
      case 2:
        return [
          "NLW(1.2.2)",
          "NLW(2.2.1)",
          "NLW(2.2.2)",
          "NLW(3.2.1)",
          "NLW(3.2.2)",
          "NLW(4.2.1)",
          "NLW(4.2.2)",
          "NLW(5.2.1)",
          "NLW(5.2.2)",
          "NLW(5.2.3)",
          "NLW(6.2.1)",
          "NLW(6.2.2)",
          "NLW(7.2.1)",
          "NLW(7.2.2)",
          "NLW(8.2.1)",
        ];
      case 3:
        return [
          "NLW(1.3.1)",
          "NLW(1.3.2)",
          "NLW(2.3.1)",
          "NLW(2.3.2)",
          "NLW(3.3.1)",
          "NLW(3.3.2)",
          "NLW(4.3.1)",
          "NLW(4.3.2)",
          "NLW(5.3.1)",
          "NLW(5.3.2)",
          "NLW(6.3.3)",
          "NLW(6.3.4)",
          "NLW(7.3.1)",
          "NLW(8.3.2)",
        ];
      case 4:
        return [
          "NLW(1.5.1)",
          "NLW(1.5.2)",
          "NLW(2.5.1)",
          "NLW(3.5.1)",
          "NLW(3.5.2)",
          "NLW(3.5.3)",
          "NLW(4.5.1)",
          "NLW(4.5.2)",
          "NLW(5.5.1)",
          "NLW(5.5.2)",
          "NLW(6.5.3)",
          "NLW(6.5.4)",
          "NLW(6.5.5)",
          "NLW(7.5.1)",
          "NLW(8.5.2)",
        ];
      default:
        return [];
    }
  }
  return [];
};

const convertNumberToGrade = (score) => {
  switch (score) {
    case 1:
      return "一";
    case 2:
      return "二";
    case 3:
      return "三";
    case 4:
      return "四";
    case 5:
      return "五";
    case 6:
      return "六";
    default:
      return "／";
  }
};

const getGradeFromScore = (itemId, score) => {
  switch (itemId) {
    case 1:
      if (score >= 1 && score <= 3) return "一";
      if (score >= 4 && score <= 6) return "二";
      if (score >= 7 && score <= 9) return "三";
      if (score >= 10 && score <= 12) return "四";
      if (score >= 13 && score <= 15) return "五";
      break;
    case 2:
      if (score === 1) return "一";
      if (score === 2) return "二";
      if (score === 3) return "三";
      if (score >= 4 && score <= 5) return "四";
      if (score >= 6 && score <= 7) return "五";
      break;
    case 3:
      if (score >= 1 && score <= 2) return "一";
      if (score >= 3 && score <= 4) return "二";
      if (score >= 5 && score <= 6) return "三";
      if (score >= 7 && score <= 8) return "四";
      if (score >= 9 && score <= 10) return "五";
      break;
    case 4:
      if (score === 0) return "零";
      if (score === 1) return "一";
      if (score === 2) return "二";
      if (score === 3) return "三";
      break;
    case 5:
      if (score >= -3 && score <= -2) return "一";
      if (score === -1) return "二";
      if (score === 0) return "三";
      break;
    default:
      return "";
  }
};

const getOverallGrade = (totalScore) => {
  if (totalScore >= 31 && totalScore <= 35) return "五";
  if (totalScore >= 26 && totalScore <= 30) return "四";
  if (totalScore >= 19 && totalScore <= 25) return "三";
  if (totalScore >= 10 && totalScore <= 18) return "二";
  if (totalScore >= 0 && totalScore <= 9) return "一";
};

const displayDate = (date) => {
  const d = new Date(date);
  return `${d.getFullYear()}年${
    d.getMonth() + 1
  }月${d.getDate()}日 ${d.getHours()}:${
    d.getMinutes() < 10 ? "0" + d.getMinutes() : d.getMinutes()
  }`;
};

function countChineseCharacters(input) {
  // Match English words and numbers
  const englishAndNumbers = input.match(/\b[A-Za-z0-9]+\b/g) || [];
  const wordCount = englishAndNumbers.length;

  // Match Chinese characters and punctuation marks
  const regex = /[\u4e00-\u9fff，。！？、；：‘’“”【】《》]/g;
  const matches = input.match(regex);
  const charCount = matches ? matches.length : 0;

  // Total count is the sum of English words/numbers and character count
  return wordCount + charCount;
}

export {
  getMaxScore,
  convertNumberToGrade,
  getNLFAccessmentScoreList,
  getGradeFromScore,
  getOverallGrade,
  displayDate,
  countChineseCharacters,
};
